
interface SelfConsumptionProps {
  data: any;
}

export function SelfConsumption({ data }: SelfConsumptionProps) {
  if (!data) return null;

  const getEfficiencyColor = (percentage: number) => {
    if (percentage >= 80) return 'text-green-700';
    if (percentage >= 60) return 'text-yellow-700';
    return 'text-orange-700';
  };

  const getEfficiencyBg = (percentage: number) => {
    if (percentage >= 80) return 'bg-green-500';
    if (percentage >= 60) return 'bg-yellow-500';
    return 'bg-orange-500';
  };

  return (
    <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl shadow-sm p-6 border-2 border-purple-200 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center justify-between mb-4">
        <div className="bg-gradient-to-br from-purple-500 to-purple-600 w-12 h-12 rounded-lg flex items-center justify-center shadow-lg">
          <i className="ri-recycle-line text-white w-6 h-6 flex items-center justify-center text-2xl"></i>
        </div>
        <div className="text-right">
          <div className="text-xs text-purple-600 font-semibold bg-purple-100 px-2 py-1 rounded-full">
            AUTOCONSUMO
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Autoconsumo
      </h3>

      <div className="space-y-3">
        <div>
          <div className="flex items-baseline space-x-1 mb-1">
            <span className="text-3xl font-bold text-purple-700">
              {data.total.toFixed(1)}
            </span>
            <span className="text-sm font-semibold text-purple-600">kWh</span>
          </div>
          <p className="text-xs text-gray-600">Total autoconsumido</p>
        </div>

        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-purple-200">
          <div>
            <div className={`text-lg font-bold ${getEfficiencyColor(data.percentage)}`}>
              {data.percentage.toFixed(0)}%
            </div>
            <p className="text-xs text-gray-600">Autoconsumo</p>
            <div className="w-full bg-purple-200 rounded-full h-1.5 mt-1">
              <div 
                className={`${getEfficiencyBg(data.percentage)} h-1.5 rounded-full transition-all duration-500`}
                style={{ width: `${data.percentage}%` }}
              ></div>
            </div>
          </div>
          
          <div>
            <div className={`text-lg font-bold ${getEfficiencyColor(data.autonomy)}`}>
              {data.autonomy.toFixed(0)}%
            </div>
            <p className="text-xs text-gray-600">Autonomía</p>
            <div className="w-full bg-purple-200 rounded-full h-1.5 mt-1">
              <div 
                className={`${getEfficiencyBg(data.autonomy)} h-1.5 rounded-full transition-all duration-500`}
                style={{ width: `${data.autonomy}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      {/* Indicadores de eficiencia */}
      <div className="mt-4 space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600">Eficiencia energética:</span>
          <span className={`font-bold ${getEfficiencyColor(data.percentage)}`}>
            {data.percentage >= 80 ? 'Excelente' : data.percentage >= 60 ? 'Buena' : 'Mejorable'}
          </span>
        </div>
        
        {/* Gráfico circular de autoconsumo */}
        <div className="flex items-center justify-center">
          <div className="relative w-16 h-16">
            <svg className="w-16 h-16 transform -rotate-90" viewBox="0 0 36 36">
              <path
                className="text-purple-200"
                stroke="currentColor"
                strokeWidth="3"
                fill="transparent"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                className={getEfficiencyColor(data.percentage).replace('text-', 'text-')}
                stroke="currentColor"
                strokeWidth="3"
                strokeDasharray={`${data.percentage}, 100`}
                strokeLinecap="round"
                fill="transparent"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className={`text-xs font-bold ${getEfficiencyColor(data.percentage)}`}>
                {data.percentage.toFixed(0)}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
        <span className="text-xs text-gray-600 font-medium">Optimizando consumo</span>
      </div>
    </div>
  );
}
